export type StatusChipColor = 'default' | 'primary' | 'success' | 'warning' | 'error';

export type StatusChipProps = {
  color: StatusChipColor;
  variant?: 'filled' | 'outlined';
};

export const BROADCAST_STATUS_CHIP_PROPS: Record<string, StatusChipProps> = {
  scheduled: { color: 'primary', variant: 'outlined' },
  completed: { color: 'default', variant: 'outlined' },
  offline: { color: 'default', variant: 'outlined' },
  draft: { color: 'default', variant: 'outlined' },
  'no-schedule': { color: 'warning', variant: 'outlined' },
};

export const SOURCE_STATUS_CHIP_PROPS: Record<string, StatusChipProps> = {
  live: { color: 'error', variant: 'filled' },
  connected: { color: 'success', variant: 'outlined' },
  disconnected: { color: 'warning', variant: 'outlined' },
  error: { color: 'error', variant: 'outlined' },
  scheduled: { color: 'primary', variant: 'outlined' },
  notscheduled: { color: 'default', variant: 'outlined' },
};

export const getBookingsCountChipProps = (count: number): StatusChipProps =>
  count > 0 ? { color: 'primary', variant: 'outlined' } : { color: 'default', variant: 'outlined' };
